export enum ConfigKeys {
    PRICE_SIMULATOR = 'priceSimulator',
    PRICING_SIMULATOR = 'pricingSimulator',
    PVM_ANALYSIS = 'pvmAnalysis',
    COMMON_CONFIG = 'commonConfig',
    PORTFOLIO_ANALYSIS = 'portfolioAnalysis',
    TPO = 'tpo',
    BEST_WEEKS = 'bestWeeks',
}

export enum KeyTypes {
    STRING = 'string',
    OBJECT = 'object',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
}

export enum priceSimulatorErrorMessages {
    MAX_LENGTH = 'Scenario name cannot exceed 50 characters',
    MIN_LENGTH = 'Please enter minimum of 3 characters',
    DUPLICATE_NAME = 'The given scenario name already exists',
    INVALID_CHAR = 'The given scenario name already exists',
}

export enum priceAnalyticsErrorMessages {
    MAX_LENGTH = 'Report name cannot exceed 50 characters',
    MIN_LENGTH = 'Please enter minimum of 3 characters',
    DUPLICATE_NAME = 'The given report name already exists',
    INVALID_CHAR = 'The given report name already exists',
}

export enum pricingSimulatorErrorMessages {
    MAX_LENGTH_PRICING_SIMULATOR = 'Scenario name cannot exceed 50 characters',
    MAX_LENGTH_PRICING_ANALYTICS = 'Report name cannot exceed 50 characters',
}

export enum PriceSimulatorSteps {
    GO_BACK = 0,
    GOAL_STEP = 1,
    PORTFOLIO_UPDATE_STEP = 2,
    IDENTIFY_OPPORTUNITY_STEP = 3,
    SIMULATE = 4,
}

export type PricingSimulatorStatusType = 'IN_PROGRESS' | 'ACTIVE' | 'DRAFT' | 'SETUP' | 'EXPIRED' | 'ERROR' | 'INVALID';
export type PricingSimulatorUploadStatusType = 'IN_PROGRESS' | 'ERROR' | 'SUCCESS';
export type TPOStatusType = 'IN_PROGRESS' | 'ACTIVE' | 'DRAFT' | 'SETUP' | 'EXPIRED' | 'ERROR' | 'INVALID';

export enum ErrorMessages {
    GENERALIZED_ERROR_MSG = 'Something went wrong, Please try again',
}

export enum PricingSimulatorNotificationMessages {
    GENERALIZED_ERROR_MSG = 'Something went wrong, Please try again',
    LENS_CONFIG_FAILED = 'Failed to save lens config',
    LENS_CONFIG_SUCCESS = 'Lens config saved successfully',
    DELETE_CUSTOM_LENS_SUCCESS_TITLE = 'User Lens Deleted',
    DELETE_CUSTOM_LENS_SUCCESS_DESCRIPTION = 'User Lens has been successfully deleted',
    DELETE_CUSTOM_LENS_FALLBACK_TITLE = 'Active lens deleted',
    DELETE_CUSTOM_LENS_FALLBACK_DESCRIPTION = 'Switched to Price.',
    CREATE_CUSTOM_LENS_SUCCESS_TITLE = 'New Custom Lens Created',
    UPDATE_CUSTOM_LENS_SUCCESS_TITLE = 'Saved Changes',
    UPDATE_CUSTOM_LENS_SUCCESS_DESCRIPTION = 'Changes has been saved successfully',
    CREATE_PROJECT_SUCCESS = 'Project created successfully',
    EDIT_PROJECT_SUCCESS = 'Project updated successfully',
    EDIT_SCENARIO_COLUMN_SUCCESS = 'Scenario updated successfully',
    DELETE_SCENARIO_SUCCESS = 'Scenario deleted successfully',
    SIMULATE_SCENARIO_SUCCESS = 'Simulation request has been successfully added to the queue',
    SIMULATE_SCENARIO_ERROR = 'Simulation failed, Please try again',
    CREATE_SCENARIO_ERROR = 'Create new scenario failed, Please try again',
    CREATE_SCENARIO_SUCCESS = 'New Scenario created',
    RENAME_SCENARIO_SUCCESS = 'Scenario renamed successfully',
    DUPLICATE_SCENARIO_SUCCESS = 'Scenario duplicated successfully',
    SCENARIO_ACTION_ERROR = 'Scenario action failed, Please try again',
    RESET_SCENARIO_SUCCESS = 'Scenario reset successfully',
    MIN_ONE_SCENARIO_FOR_PROJECT = 'A project should have at least one scenario',
    SCENARIO_EXPORT_QUEUE = 'Export request has been successfully added to the queue. We are processing it and will notify you once its ready for download',
    SCENARIO_EXPORT_DOWNLOAD_MESSAGE = 'Export is ready! The download has started automatically',
    END_DATE_ERROR = 'end date should be greater than current date',
    PRICE_EFFECTIVE_DATE_ERROR = 'price effective date should be between simulation date',
}

export enum PricingAnalyticsNotificationMessages {
    BASE_SCENARIO_SUCCESS = 'Base Scenario added Successfully',
}

export enum tpoReactQueryKeyConstants {
    GET_ALL_PLANS = 'tpo-index-table-plans',
}

export enum loginErrors {
    GENERIC_LOGIN_ERROR = 'Authentication failed. Please try again.',
    INVALID_CREDENTIALS = 'Invalid email id or password. Please try again.',
}

export enum tpoNotificationMessages {
    CREATE_PLAN_SUCCESS = 'Plan successfully created',
    EDIT_PLAN_SUCCESS = 'Plan successfully updated',
    CREATE_EVENT_SUCCESS = 'Event successfully created',
    EDIT_EVENT_SUCCESS = 'Event successfully updated',
    DELETE_EVENT_SUCCESS = 'Event successfully deleted',
    DELETE_EVENT_ERROR = 'Failed to delete event',
    COPY_EVENT_SUCCESS = 'Event successfully copied',
    IMPORT_EVENT_SUCCESS = 'Events successfully imported',
    TPM_SYNC_SUCCESS = 'Successfully synced with TPM',
    OPTIMIZATION_SYNC_SUCCESS = 'Successfully synced optimization plan with TPO',
    EVENT_DELETION_SUCCESS = 'Event successfully deleted',
    CREATE_EVENT_LIBRARY_SUCCESS = 'Event Library successfully created',
    EDIT_PLAYBOOK_SUCCESS = 'Guideline successfully updated',
    EDIT_KEEP_DATES_PROMO_SUCCESS = 'Promo successfully updated',
    EDIT_PROMO_LIBRARY_SUCCESS = 'Metric successfully updated',
    RESET_PROMO_LIBRARY_SUCCESS = 'Promo library successfully reset',
    PLAN_EXPORT_QUEUE = 'Export request has been successfully added to the queue. We will notify you once its ready for download',
    PLAN_EDIT_ACQUIRE_SUCCESS = 'Plan edit permission acquired',
    PLAN_EDIT_RELEASE_SUCCESS = 'Plan edit mode exited successfully',
    PLAN_EDIT_EXTEND_SUCCESS = 'Plan edit session extended successfully',
    EDIT_TOOLS_SCROLL_INFO = 'Scroll reset applied: data length exceeded.',
}

export enum tpoPromoMetricKeys {
    PROMOTED_SRP = 'promoted_srp',
    EDLP_SRP = 'edlp_srp',
    EDLP_SRP_TRUE = 'edlp_srp_true',
    SRP_TRUE = 'srp_true',
    LIST_PRICE = 'list_price_per_unit',
    SRP = 'srp',
    OI_RATE = 'off_invoice_rate',
    OI_PERCENT = 'off_invoice_percent',
    NBOI_RATE = 'nboi_rate',
    BILL_BACK_RATE = 'bill_back_rate',
    BILL_BACK_PERCENT = 'bill_back_percent',
    FIXED_MISC = 'fixed_misc',
    SCAN_VOLUME = 'scan_volume',
    SCAN_RATE = 'scan_rate',
    TPO_Uplift_Percent = 'tpo_uplift_percent',
    EDLP_NBOI_RATE = 'edlp_nboi_rate',
    EDLP_BILL_BACK_RATE = 'edlp_bill_back_rate',
    EDLP_OI_RATE = 'edlp_oi_rate',
    EDLP_PERCENT = 'edlp_percent',
    EDLP_SCAN_RATE = 'edlp_scan_rate',
    EDLP_FIXED_MISC = 'edlp_fixed_misc',
    TPO_ADJUSTED_BASE_UNITS = 'tpo_adjusted_base_units',
    TPO_INCREMENTAL_UNITS = 'tpo_incremental_units',
    TPO_TOTAL_UNITS = 'tpo_total_units',
    SCAN_REDEMPTION_PERCENT = 'scan_redemption_percent',
    TOTAL_PROMO_SPENDS = 'total_promo_spends',
    NET_PRICE_INCL_MDF_PER_UNIT = 'net_price_incl_mdf_per_unit',
    NET_PRICE_PER_STAT = 'net_price_per_stat',
    GROSS_MARGIN_DOLLARS = 'gross_margin_dollars',
    CONSUMPTION_MPIC_STAT = 'consumption_mpic_stat',
    PROMOTED_AUR = 'promoted_aur',
    COUPON_OR_OVERLAY_VALUE = 'coupon_or_overlay_value',
    PERCENT_OF_CONSUMPTION = 'percent_of_consumption',
    FEATURE_ACV_PERCENT = 'feat_acv_percent',
    DISPLAY_ACV_PERCENT = 'disp_acv_percent',
    EDLP_SPENDS = 'edlp_spends',
    STAND_ALONE_NET_PRICE = 'stand_alone_net_price',
    // STAND_ALONE_NET_PRICE_PER_UNIT = 'stand_alone_net_price_per_unit', not being used we can remove it later
    TPM_PLANNED_SHIPMENT_VOLUME = 'tpm_planned_shipment_volume',
    FIXED_COUPON_CLEARING_HOUSE = 'fixed_coupon_clearing_house',
    FIXED_NON_COUPON_CLEARING_HOUSE = 'fixed_non_coupon_clearing_house',
    FIXED_PROGRAM_COST = 'fixed_program_cost',
    STAND_ALONE_INC_GROSS_MARGIN_DOLLARS = 'stand_alone_Inc_gross_margin_dollars',
    SCAN_VOLUME_ISOLATED = 'scan_volume_isolated',
    COGS_PER_UNIT = 'cogs_per_unit',
}

export enum PromotionTypes {
    EDLP = 1,
    Merchandising = 2,
    SM_MDF = 3,
    SM_ISM = 4,
    Slotting = 5,
    Post_Audit = 6,
    Write_Off = 7,
}

export enum Environment {
    dev = 'dev',
    test = 'test',
    demo = 'demo',
    prod = 'prod',
    staging = 'staging',
}

export const EnvironmentMapping: Record<Environment, string> = {
    [Environment.dev]: 'staging',
    [Environment.test]: 'test',
    [Environment.demo]: 'staging',
    [Environment.prod]: 'prod',
    [Environment.staging]: 'staging',
};
